import { STATES, ITEM_KINDS, STEP_URLS } from '@mover-app/constants';

export const BASE_PATH = STEP_URLS.STEP_PACKING_SUPPLIES;
export function PackingSuppliesConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_PACKING_SUPPLIES, {
    url: `${BASE_PATH}`,
    disableBreadcrumb: true,
    title: '',
    views: {
      '@': {
        template: '<div>Order Packing Supplies</div>',
      },
    },
    scrollTop: true,
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.PACKING_SUPPLIES,
        singleton: true,
      },
    },
    resolve: {
      guard: () => {
        return new Promise(() => {
          window.location.href = '/n/quick-setup/packing-supplies/moving-kits';
        });
      },
    },
  });
}
